import { useState } from 'react'

import { useTranslation } from 'utils/use-translation'

import styles from './styles.module.scss'

import TitleIcon from './icons/title.svg'
import QuestionIcon from './icons/question.svg'
import DotGridIcon from './icons/dot grid.svg'
import MegaphoneIcon from './icons/megaphone.png'
import BallIcon from './icons/ball.svg'
import StarIcon from './icons/star top.svg'
import StarIconMobile from './icons/star-mobile.svg'
import InviteCalculator from './invite-calculator'

export default function InviteFriends({ handleGoToRefferal }) {
  const { t } = useTranslation()
  const [isHovered, setIsHovered] = useState(false)

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  return (
    <section className={styles.wrapper}>
      <div className={styles.wrapper__left}>
        <div className={styles.wrapper__title}>
          <h1 className={styles.desktopTitle}>
            <span className={styles.headerSpan}>Invite Friends</span>
            <img className={styles.titleIcon} src={TitleIcon} alt="title icon" />
            <br className={styles.desktopBr} />
            <span>{t('get_free_crypto')}</span>
          </h1>
        </div>
        <div className={styles.wrapperDescription}>
          <p className={styles.wrapper__subtitle}>{t('invite_friends_sign_up')}</p>
          <img className={styles['wrapper__dot-grid']} src={DotGridIcon} alt="dot grid icon" />
          <img className={styles.wrapper__megaphone} src={MegaphoneIcon} alt="exchange arrows icon" />
        </div>
      </div>

      <div className={styles.wrapper__right}>
        <div className={styles.calculator}>
          <InviteCalculator handleGoToRefferal={handleGoToRefferal} />
          <img className={styles.wrapper__ball} src={BallIcon} alt="ball buttom icon" />
          <div
            className={styles.wrapper__percent}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ height: isHovered ? 'fit-content' : '58px' }}
          >
            <h1>
              {t('apr_rate')}
              <img className={styles.wrapper__question} src={QuestionIcon} alt="Question icon" />
            </h1>
            <div className={styles.wrapper__percent__content}>
              <p>{t('you_recieve_monthly')}</p>
            </div>
          </div>
        </div>
      </div>

      <img className={styles.wrapper__starTop} src={StarIcon} alt="star top icon" />
      <img className={styles.wrapper__starRight} src={StarIcon} alt="star right icon" />
      <img className={styles.wrapper__starMobile} src={StarIconMobile} alt="star right icon" />
    </section>
  )
}
